/* FORCE · Cambio de idioma del sitio (español → inglés) sin tocar las secciones.
   Diccionario de textos exactos (window.FORCE_I18N_EN) + reglas para textos con números (window.FORCE_I18N_RULES).
   Traduce nodos de texto y atributos (placeholder, title, aria-label, alt, value de botones), también dentro de
   Shadow DOM (Portal del Atleta), y sigue traduciendo lo que se renderiza después (ranking, fichas, portal) con
   MutationObserver. Se activa con la bandera del encabezado, con ?lang=en en la URL o con la preferencia guardada.
   Este archivo se carga antes que todo lo demás: para volver a español se recarga la página. */
(function () {
  var W = window, D = document, KEY = 'force_lang';
  function readPref() {
    var q = null;
    try { q = new URLSearchParams(location.search).get('lang'); } catch (e) {}
    if (q === 'en' || q === 'es') { save(q); return q; }
    try { var v = localStorage.getItem(KEY); if (v === 'en' || v === 'es') return v; } catch (e) {}
    try { var m = /(?:^|; )force_lang=(en|es)/.exec(D.cookie); if (m) return m[1]; } catch (e) {}
    return 'es';
  }
  function save(v) {
    try { localStorage.setItem(KEY, v); } catch (e) {}
    try { D.cookie = KEY + '=' + v + '; path=/; max-age=31536000; SameSite=Lax'; } catch (e) {}
  }
  var lang = readPref();
  W.FORCE_LANG = lang;
  W.forceSetLang = function (v) {
    if (v !== 'en' && v !== 'es') return;
    save(v);
    // Quita ?lang= de la URL para que la preferencia guardada mande, y recarga limpio.
    try { var u = new URL(location.href); u.searchParams.delete('lang'); location.replace(u.href); } catch (e) { location.reload(); }
  };
  D.documentElement.setAttribute('data-lang', lang);
  if (lang !== 'en') return;

  D.documentElement.lang = 'en';
  D.documentElement.classList.add('lang-en');

  var DICT = W.FORCE_I18N_EN || {};
  var RULES = W.FORCE_I18N_RULES || [];
  // El diccionario viene en un archivo aparte (solo se carga en inglés). Hasta que llegue, la página queda oculta
  // (máximo 2 s) para no mostrar español un instante.
  var me = D.currentScript, dictUrl = me && me.getAttribute('data-dict');
  var ready = !dictUrl || !!W.FORCE_I18N_EN;
  W.forceI18nDict = function (dict, rules) {
    DICT = dict || DICT; RULES = rules || RULES; ready = true;
    D.documentElement.classList.remove('lang-en-pending');
    walk(D); flushTitle();
    if (queue.length) { scheduled = false; flush(); }
  };
  if (!ready) {
    D.documentElement.classList.add('lang-en-pending');
    try { var st = D.createElement('style'); st.textContent = 'html.lang-en-pending body{visibility:hidden}'; D.head.appendChild(st); } catch (e) {}
    setTimeout(function () { D.documentElement.classList.remove('lang-en-pending'); }, 2000);
    try { var sc = D.createElement('script'); sc.src = dictUrl; sc.async = false; D.head.appendChild(sc); } catch (e) {}
  }
  var ATTRS = ['placeholder', 'title', 'aria-label', 'alt', 'data-tooltip'];
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, CODE: 1, PRE: 1, TEXTAREA: 1 };
  var lastOut = new WeakMap();   // nodo → último texto escrito por nosotros
  var origOf = new WeakMap();    // nodo → texto original (español)
  var attrOrig = new WeakMap();  // elemento → { atributo: original }
  var observed = new WeakSet();  // raíces ya observadas (document / shadow roots)

  function norm(s) { return String(s).replace(/\s+/g, ' ').trim(); }
  function lookup(k) {
    var v = DICT[k];
    if (v != null) return v;
    // Reglas encadenadas: cada una que calce transforma el texto y se sigue con la siguiente.
    var out = k, changed = false;
    for (var i = 0; i < RULES.length; i++) {
      var re = RULES[i][0];
      re.lastIndex = 0;
      if (re.test(out)) { re.lastIndex = 0; var nx = out.replace(re, RULES[i][1]); if (nx !== out) { out = nx; changed = true; } }
    }
    if (changed) { var v2 = DICT[out]; return v2 != null ? v2 : out; }
    return null;
  }
  function translate(s) {
    var k = norm(s);
    if (!k) return null;
    var v = lookup(k);
    if (v != null) return v;
    // Variantes: mayúsculas completas ("INSCRÍBETE") y final con dos puntos
    var up = k === k.toUpperCase() && k !== k.toLowerCase();
    if (up) { var v2 = lookup(k.charAt(0) + k.slice(1).toLowerCase()); if (v2 == null) v2 = lookup(capWords(k)); if (v2 == null) v2 = lookup(k.toLowerCase()); if (v2 != null) return v2.toUpperCase(); }
    if (k.charAt(0) === k.charAt(0).toUpperCase() && k.charAt(0) !== k.charAt(0).toLowerCase()) { var v4 = lookup(k.charAt(0).toLowerCase() + k.slice(1)); if (v4 != null) return v4.charAt(0).toUpperCase() + v4.slice(1); }
    var m = /^(.*?)([:.…!?]+)$/.exec(k);
    if (m) { var v3 = lookup(m[1]); if (v3 != null) return v3 + m[2]; }
    // Separadores al inicio o al final ("· jueves 15 de octubre", "Fútbol ·", "(2 fotos)"): se traduce el centro.
    var sep = /^([·•|\-–—:,(]\s*)?([\s\S]*?)(\s*[·•|\-–—:,)])?$/.exec(k);
    if (sep && (sep[1] || sep[3]) && sep[2] && sep[2] !== k) { var v5 = translate(sep[2]); if (v5 != null) return (sep[1] || "") + v5 + (sep[3] || ""); }
    return null;
  }
  function capWords(s) { return s.toLowerCase().replace(/(^|\s)(\S)/g, function (a, b, c) { return b + c.toUpperCase(); }); }
  function skipEl(el) {
    for (var e = el; e && e.nodeType === 1; e = e.parentNode || e.host) {
      if (SKIP[e.tagName] || e.getAttribute('translate') === 'no' || e.classList.contains('notranslate')) return true;
    }
    return false;
  }
  function doText(node) {
    var cur = node.data;
    if (!/[A-Za-zÁÉÍÓÚÑáéíóúñ]/.test(cur)) return;
    if (cur === lastOut.get(node)) return;           // lo escribimos nosotros
    var p = node.parentNode;
    if (!p || skipEl(p.nodeType === 11 ? p.host : p)) return;
    origOf.set(node, cur);
    var t = translate(cur);
    if (t == null) return;
    var m = /^(\s*)[\s\S]*?(\s*)$/.exec(cur);
    var out = m[1] + t + m[2];
    if (out !== cur) { lastOut.set(node, out); node.data = out; }
  }
  function doAttrs(el) {
    if (skipEl(el)) return;
    for (var i = 0; i < ATTRS.length; i++) {
      var a = ATTRS[i];
      if (!el.hasAttribute(a)) continue;
      var v = el.getAttribute(a);
      var o = attrOrig.get(el) || {};
      if (o[a] && o[a].out === v) continue;
      var t = translate(v);
      if (t == null) continue;
      o[a] = { orig: v, out: t }; attrOrig.set(el, o);
      el.setAttribute(a, t);
    }
    if ((el.tagName === 'INPUT' && /^(submit|button)$/i.test(el.type)) && el.value) {
      var o2 = attrOrig.get(el) || {};
      if (!(o2.value && o2.value.out === el.value)) { var tv = translate(el.value); if (tv != null) { o2.value = { orig: el.value, out: tv }; attrOrig.set(el, o2); el.value = tv; } }
    }
    if (el.tagName === 'META' && (el.name === 'description' || /^og:(title|description)$/.test(el.getAttribute('property') || ''))) {
      var c = el.getAttribute('content'); var tc = c && translate(c); if (tc != null && tc !== c) el.setAttribute('content', tc);
    }
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { doText(root); return; }
    if (root.nodeType === 1) { doAttrs(root); if (root.shadowRoot) observe(root.shadowRoot); }
    var it = D.createTreeWalker(root, 4 | 1, null);
    var n;
    while ((n = it.nextNode())) {
      if (n.nodeType === 3) doText(n);
      else { doAttrs(n); if (n.shadowRoot) observe(n.shadowRoot); }
    }
  }
  var queue = [], scheduled = false;
  function flushTitle() { if (D.title) { var tt = translate(D.title); if (tt != null && tt !== D.title) D.title = tt; } }
  function flush() {
    scheduled = false;
    var q = queue; queue = [];
    if (!ready) { queue = q; return; }
    for (var i = 0; i < q.length; i++) walk(q[i]);
    flushTitle();
  }
  function enqueue(n) { queue.push(n); if (!scheduled) { scheduled = true; (W.requestAnimationFrame || setTimeout)(flush); } }
  function observe(root) {
    if (observed.has(root)) return;
    observed.add(root);
    if (ready) walk(root); else enqueue(root);
    try {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var m = muts[i];
          if (m.type === 'characterData') enqueue(m.target);
          else if (m.type === 'attributes') enqueue(m.target);
          else for (var j = 0; j < m.addedNodes.length; j++) enqueue(m.addedNodes[j]);
        }
      }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
    } catch (e) { /* sin observer: solo la primera pasada */ }
  }
  // Shadow roots que se creen después (el portal monta su interfaz dentro de uno)
  try {
    var attach = Element.prototype.attachShadow;
    Element.prototype.attachShadow = function (init) { var r = attach.call(this, init); try { observe(r); } catch (e) {} return r; };
  } catch (e) {}

  W.forceI18nApply = function (root) { walk(root || D); };
  W.forceI18nTranslate = translate;
  W.forceI18nMissing = function (root) {
    // Para verificación: textos que siguen en español (con acentos/ñ o palabras frecuentes) dentro de root.
    var out = {}; var it = D.createTreeWalker(root || D, 4, null); var n;
    var es = /(^|[^A-Za-zÁÉÍÓÚÑáéíóúñ])(el|la|los|las|del|con|para|por|que|una|uno|tu|tus|más|aquí|ver|desde|hasta|sin|sobre|cada|todo|todos|todas|nuestro|nuestra|son|está|están|hay|este|esta|esto|estos|estas|ya|aún|también|solo|sólo|como|cuando|donde|pero|muy|años|año|fecha|fechas|oficial|perfil|atleta|atletas|prueba|pruebas|marca|marcas|puntaje|inscríbete|inscripción|envío|gratis|comprar|agregar|carro|ahorra|arma|tienda|ingresar|cuenta|entrar|cerrar|abrir|menú|buscar|región|regiones|categoría|edad|estatura|peso|deporte|hombres|mujeres|equipo|nuevo|nueva|nuevos|nuevas|gracias|siguiente|anterior|volver|cargando|enviar|guardar|borrar|editar|publicar|aviso|avisos|fotos|mis|nos|sus|unos|unas|sí)([^A-Za-zÁÉÍÓÚÑáéíóúñ]|$)/i;
    var skipHint = /^(Desafío Sammis Reyes|Desafío|FORCE.*|Arica y Parinacota|O[’']Higgins|La Araucanía|Los Ríos|Los Lagos|.* · (La Serena|El Bosque|Los Andes|La Florida|Las Condes|La Reina|La Pintana|El Monte|Lo Barnechea|Lo Prado|Lo Espejo)|Isla de Pascua|Elige o elegirán por ti)$/;
    while ((n = it.nextNode())) { var k = norm(n.data); if (!k || k.length < 2) continue; if (!es.test(k) || skipHint.test(k)) continue; if (skipEl(n.parentNode)) continue; if (translate(k) != null) continue; out[k] = (out[k] || 0) + 1; }
    for (var el of (root || D).querySelectorAll('[placeholder],[title],[aria-label],[alt]')) { for (var a of ['placeholder','title','aria-label','alt']) { var v = el.getAttribute(a); if (v && es.test(v) && translate(v) == null && !skipEl(el)) out['@' + a + ': ' + norm(v)] = 1; } }
    return out;
  };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { observe(D); }); else observe(D);
  // El <head> y <html> ya existen: título y metas
  observe(D);
})();
